'use client'

import SuperTokens from 'supertokens-auth-react'
import SessionReact from 'supertokens-auth-react/recipe/session'
import ThirdPartyReact, { Google } from 'supertokens-auth-react/recipe/thirdparty'
import PasswordlessReact from 'supertokens-auth-react/recipe/passwordless'

import { getAuthRoute, getSuccessRedirectPath, getSuperTokensAppInfo } from '@/lib/supertokens-config'

let initialized = false

const isDevAuthBypass = process.env.NEXT_PUBLIC_DEV_AUTH_BYPASS === 'true'

export function ensureSuperTokensClientInit() {
  if (initialized || typeof window === 'undefined') {
    return
  }

  SuperTokens.init({
    appInfo: getSuperTokensAppInfo(),
    recipeList: [
      SessionReact.init({
        override: isDevAuthBypass
          ? {
              functions: (originalImplementation) => ({
                ...originalImplementation,
                shouldDoInterceptionBasedOnUrl: () => false,
              }),
            }
          : undefined,
      }),
      ThirdPartyReact.init({
        signInAndUpFeature: {
          providers: [Google.init()],
        },
      }),
      PasswordlessReact.init({
        contactMethod: 'EMAIL',
      }),
    ],
    getRedirectionURL: async (context) => {
      if (context.action === 'TO_AUTH') {
        return getAuthRoute()
      }

      if (context.action === 'SUCCESS') {
        return getSuccessRedirectPath()
      }

      return undefined
    },
  })

  initialized = true
}
